"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TimePicker = exports.DatePicker = exports.MuiPickersProvider = void 0;
// https://material-ui-pickers.firebaseapp.com/installation
// TODO handle date and time localization https://material-ui-pickers.firebaseapp.com/localization/moment
var moment_1 = __importDefault(require("@date-io/moment"));
var pickers_1 = require("@material-ui/pickers");
var react_1 = __importDefault(require("react"));
var DatePicker_1 = require("./DatePicker");
Object.defineProperty(exports, "DatePicker", { enumerable: true, get: function () { return DatePicker_1.DatePicker; } });
var TimePicker_1 = require("./TimePicker");
Object.defineProperty(exports, "TimePicker", { enumerable: true, get: function () { return TimePicker_1.TimePicker; } });
var MuiPickersProvider = function (props) { return (react_1.default.createElement(pickers_1.MuiPickersUtilsProvider, __assign({ utils: moment_1.default }, props))); };
exports.MuiPickersProvider = MuiPickersProvider;
//# sourceMappingURL=index.js.map